<template>
  <div>
    <div class="install-card" :class="{ price: showPrice }">
      <div :class="`card-title ${$i18n.locale}`">{{ encourageText }}</div>

      <div class="copy-btn-wrapper">
        <button class="btn-copy btn-shrink" @click="copyCode()">
          {{ code }}
        </button>
        <img
          src="/img/programs/study-abroad/lpIconPromotionCodeCopy.png"
          alt="[Copy]"
          class="copy-window"
        />
      </div>

      <div class="price-wrapper">
        <price v-if="showPrice" :program-key="programKey" />
      </div>

      <div class="install-btn-wrapper">
        <install-btns :big="true"></install-btns>
      </div>

      <div class="text-download">
        {{ $t('study-abroad.join.download-text') }}
      </div>
    </div>

    <v-snackbar v-model="snack" color="white">
      <v-layout justify-space-between>
        <div class="font-black">Copied!</div>
        <v-btn text color="black" @click.native="snack = false">Close</v-btn>
      </v-layout>
    </v-snackbar>
  </div>
</template>

<script>
import { getCodeWithSuffix } from '../../../utils/programs/study_abroad_utils';

const Price = () => import('./Price');
const InstallBtns = () => import('../App/InstallBtns');

export default {
  components: {
    Price,
    InstallBtns,
  },
  props: ['showPrice', 'programKey'],

  data() {
    let isHomin = this.programKey == 'homin';

    let encourageText = '';
    if (isHomin) {
      encourageText = this.$t('study-abroad.join.encourage-text-homin');
    } else {
      encourageText = this.$t('study-abroad.join.encourage-text');
    }

    let suffixId = '';
    if (isHomin) {
      suffixId = 'homin';
    } else if (this.$route.name.includes('mayu')) {
      suffixId = 'mayu';
    } else {
      suffixId = this.$route.params.codeSuffixId;
    }

    let code = getCodeWithSuffix(suffixId);

    return {
      encourageText: encourageText,
      code: code,
      snack: false,
    };
  },

  methods: {
    copyCode() {
      navigator.clipboard.writeText(this.code);
      this.snack = true;
    },
  },
};
</script>

<style scoped>
.install-card {
  background-image: url('/img/lp/lpFrmPromotionCode.png');
  background-size: cover;
  padding: 48px 0 40px;
  text-align: center;
  background-position: center;
}
.install-card.price {
  background-image: url('/img/lp/lpFrmPromotionCodeLarge.png');
}
.card-title {
  font-size: 40px;
  color: #fff;
  font-weight: bold;
  line-height: 1.2em;
  white-space: pre-wrap;
}
.copy-btn-wrapper {
  width: max-content;
  margin: 48px auto 0;
  position: relative;
}
.btn-copy {
  height: 70px;
  color: rgb(56, 55, 55);
  padding: 0px 30px;
  font-size: 46px;
  font-weight: bold;
  border-radius: 6px;
  background-color: #fff;
  outline: none;
}
.btn-copy:hover {
  background-color: rgb(56, 55, 55);
  color: #fff;
}
.copy-window {
  position: absolute;
  width: 120px;
  right: -130px;
  top: -4px;
}
.price-wrapper {
  margin-top: 48px;
}
.install-btn-wrapper {
  margin-top: 48px;
}
.text-download {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-top: 8px;
}
@media (min-width: 768px) {
  .visible-xs {
    display: none;
  }
}
@media (max-width: 1023px) {
  .card-title {
    font-size: 32px;
  }
  .btn-copy {
    font-size: 36px;
    height: 56px;
  }
  .copy-window {
    width: 100px;
    right: -110px;
  }
}
@media (max-width: 767px) {
  .install-card {
    padding: 12px 0 16px;
  }
  .card-title {
    font-size: 16px;
  }
  .card-title.ja {
    font-size: 18px;
  }
  .copy-btn-wrapper {
    margin-top: 24px;
  }
  .btn-copy {
    font-size: 18px;
    height: 36px;
    padding: 0 12px;
  }
  .copy-window {
    width: 60px;
    right: -70px;
    top: 0;
  }
  .price-wrapper {
    margin-top: 24px;
  }
  .install-btn-wrapper {
    margin-top: 24px;
  }
  .text-download {
    font-size: 12px;
    margin-top: 0;
  }
}
@media (max-width: 360px) {
  .card-title {
    font-size: 14px;
  }
  .card-title.ja {
    font-size: 16px;
  }
  .btn-copy {
    font-size: 16px;
    height: 30px;
  }
  .copy-window {
    width: 50px;
    right: -56px;
  }
}
</style>
